window.menuOpen = false

;(function () {
  const $burger = $('[data-burger]')
  const $header = $('.page-header')
  const $menu = $('.page-header .menu-wrapper')
  const $searchForm = $('.page-header .search-wrapper')

  $burger.on('click', function () {
    const $this = $(this)
    const $burgerIcon = $this.find('.burger')
    const $menuText = $this.find('.menu-btn-text')

    const isOpen = $burgerIcon.hasClass('burger-active')

    $burgerIcon.toggleClass('burger-active')
    $menu.toggleClass('active')
    $('html, body').toggleClass('overflow-hidden', !isOpen)

    if (!isOpen) {
      lenis.stop()
      menuOpen = true // Đánh dấu đang mở menu
      $menuText.text('Đóng')
      // $header.addClass('fixed')
    } else {
      lenis.start()
      menuOpen = false // Đóng menu -> bật lại scroll
      $menuText.text('Menu')
      // $header.removeClass('fixed')
      $searchForm.removeClass('active')
    }
  })
})()
